import {axiosGetHandler, axiosPostHandler} from '../../config'
import { getUrlParam } from '_lib/utils'

class HeyboxRequest {
  static get = axiosGetHandler 
  static post = axiosPostHandler 
  static base () {
    return axiosGetHandler('/bbs/app/link/web/view', {
      return_json: 1,
      link_id: getUrlParam('link_id') || window.$LINK_ID_DEV || ''
    }).then(res => {
      return {
        content: res.data,
        type: 'content',
        url: 'https://api.xiaoheihe.cn/bbs/app/link/web/view?link_id=26328105&return_json=1&version=1.3.295&os_version=14&x_app=heybox'
      }
    })
  }
}

window.HeyboxRequest = HeyboxRequest